module.exports = __webpack_public_path__ + "static/media/Inter-Bold.e7ae9868.woff2";